import { CoreIcon } from '../core-icon';
import giftSVG from '../../assets/icons/gift.svg';
import type { IconProps } from '../core-icon';

export const GiftIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={giftSVG} {...props} />;
};
